import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    categoryListProps,
    detailProps,
    prefabricatedChatProps,
    stylesCategoryProps,
    stylesListProps,
    StyleState
} from "../types/selectStyles";

const initialState: StyleState = {
    styleCategory: [],
    styleList: [],
    styleDetail: null,
    currentStyleId: 0,
    strategyCode: '',
    initPrefabricatedChat: null,
    prefabricatedChat: []
};

export const styleSlice = createSlice({
    name: 'style',
    initialState,
    reducers: {
        setStyleCategory: (state, action: PayloadAction<stylesCategoryProps[]>) => {
            state.styleCategory = action.payload;
        },
        setStyleList: (state, action: PayloadAction<categoryListProps[]>) => {
            state.styleList = action.payload;
        },
        setStyleDetail: (state, action: PayloadAction<detailProps | null>) => {
            state.styleDetail = action.payload;
        },
        setCurrentStyleId: (state, action: PayloadAction<number>) => {
            state.currentStyleId = action.payload;
        },
        setCurrentStrategyCode: (state, action: PayloadAction<string>) => {
            state.strategyCode = action.payload;
        },
        setInitPrefabricatedChat: (state, action: PayloadAction<prefabricatedChatProps | null>) => {
            state.initPrefabricatedChat = action.payload;
        },
        setPrefabricatedChat: (state, action: PayloadAction<{text: string}[]>) => {
            state.prefabricatedChat = action.payload;
        }
    }
});

export const {
    setStyleCategory,
    setStyleList,
    setStyleDetail,
    setCurrentStyleId,
    setCurrentStrategyCode,
    setInitPrefabricatedChat,
    setPrefabricatedChat
} = styleSlice.actions;

export default styleSlice.reducer;